// extracted by mini-css-extract-plugin
module.exports = {"text":"TaMhtEditorRevisions_text__1rMWO"};